// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__KmMPB","reactPlayerContainer":"styles_reactPlayerContainer__qmPbJ","loaderContainer":"styles_loaderContainer__jFmYa","player":"styles_player__GxI1u"};